import {createSelector} from '@reduxjs/toolkit'
import {
  getBookingCreationLink,
  getBookingPaymentOptionLink
} from 'business/bofhLinks'
import {RootState} from 'store'

import {getCancellationDeadline} from '@daedalus/core/src/offer/business/cancellationPenalties'
import {
  GET_OFFER_CHECK_QUERY_KEY,
  offerCheckApi
} from '@daedalus/core/src/offer/services/offerCheckApi'
import {getEpochSeconds} from '@daedalus/core/src/utils/date'

export const getOfferCheck = (state: RootState) => {
  const queryData = offerCheckApi.endpoints.getOfferCheck.select(
    GET_OFFER_CHECK_QUERY_KEY
  )(state)

  return queryData.data
}

export const getEpochCancellationDeadline = createSelector(
  getOfferCheck,
  offer => {
    const cancellationDeadline = getCancellationDeadline(
      offer?.cancellationPenalties ?? []
    )
    return cancellationDeadline ? getEpochSeconds(cancellationDeadline) : null
  }
)

export const getOfferCheckError = (state: RootState) =>
  offerCheckApi.endpoints.getOfferCheck.select(GET_OFFER_CHECK_QUERY_KEY)(state)
    .error

export const getOfferCheckLoadingState = (state: RootState) =>
  offerCheckApi.endpoints.getOfferCheck.select(GET_OFFER_CHECK_QUERY_KEY)(state)
    .isSuccess

const getOfferCheckLinks = createSelector(
  getOfferCheck,
  offerCheck => offerCheck?.links || []
)

export const getOfferCheckPaymentLink = createSelector(
  getOfferCheckLinks,
  links => getBookingPaymentOptionLink(links)
)

export const getBookOfferCreationLink = createSelector(
  getOfferCheckLinks,
  links => getBookingCreationLink(links)
)

export const getOfferCheckMerchantOfRecord = createSelector(
  getOfferCheck,
  offerCheck => offerCheck?.merchantOfRecord
)
